export default "__VITE_ASSET__92034ccd__"